import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AcabimResource, AcabimSite, SiteApiService} from '@cas-hub/acabim-common-client';


@Component({
    selector: 'acabim-admin-edit-site',
    templateUrl: './edit-site.component.html',
    styleUrls: ['./edit-site.component.scss']
})
export class EditSiteComponent implements OnInit {
    @Output() closeDialog = new EventEmitter<string>();
    @Input() _currentSite?: AcabimResource = undefined;

    @ViewChild('editaddress', {static: false}) public child: any;
    @ViewChild('projects', {static: false}) public projects: any;
    selectedSite?: AcabimSite;
    index = 0;

    constructor(
        private readonly siteApiService: SiteApiService,
    ) {
    }

    ngOnInit(): void {
        if (this._currentSite) {
            this.siteApiService.getSite(this._currentSite.id, {includeGroups: true, includeProjects: true}).subscribe(site => {
                this.selectedSite = site;
            });
        }
    }

    onCancel() {
        this.child.ngOnDestroy();
        this.closeDialog.emit('cancel');
    }

    onUpdate(update: boolean) {
        if (update) {
            this.closeDialog.emit('update');
        }
    }

    selectTab($event: { index: number; }) {
        if ($event.index === 1 && this.projects) {
            this.projects.dataTable.requestImmediateDataRefresh();
        }
        this.index = $event.index;
    }
}
